module.exports = __webpack_public_path__ + "static/media/inspectionIcon_grey.bf34289e.svg";